import { NAV_PATH } from '@/router/constants';

// 스텔라 주요 기능 해시
export const FUNC_HASH_MAIN = Object.freeze([
	'task',
	'yeartaxset',
	'e-approval',
	'attd',
	'e-contract',
	'bareport',
	'basis',
	'transaction',
	'accountancy',
	'finance',
	'hr',
	'stock',
	'sales',
	'b2b',
	'ledger',
	'tax',
	'dms'
]);

// 스텔라 주요 기능 탭 버튼 Config
export const FUNC_MAIN_TAB_BUTTON = Object.freeze([
	{ key: 'task', label: '나의업무', hash: 'task' },
	{ key: 'yeartaxset', label: '연말정산', hash: 'yeartaxset' },
	{ key: 'e-approval', label: '전자결재', hash: 'e-approval' },
	{ key: 'attd', label: '근태관리', hash: 'attd' },
	{ key: 'e-contract', label: '전자계약', hash: 'e-contract' },
	{ key: 'bareport', label: '경영보고서', hash: 'bareport' },
	{ key: 'basis', label: '기초정보', hash: 'basis' },
	{ key: 'transaction', label: '거래수집', hash: 'transaction' },
	{ key: 'accountancy', label: '회계관리', hash: 'accountancy' },
	{ key: 'finance', label: '금융관리', hash: 'finance' },
	{ key: 'hr', label: '인사급여', hash: 'hr' },
	{ key: 'stock', label: '재고관리', hash: 'stock' },
	{ key: 'sales', label: '영업관리', hash: 'sales' },
	{ key: 'b2b', label: 'B2B 수발주', hash: 'b2b' },
	{ key: 'ledger', label: '장부/결산', hash: 'ledger' },
	{ key: 'tax', label: '세금신고', hash: 'tax' },
	{ key: 'dms', label: '제증명발급', hash: 'dms' }
]);

// 스텔라 편의 기능 해시
export const FUNC_HASH_CONV = Object.freeze([
	'account',
	'pharosAI',
	'receiptocr',
	'bookmark',
	'dashboard',
	'credit',
	'project',
	'banking',
	'withholdingTax',
	'vat',
	'taxInvoice',
	'mim',
	'report',
	'costprofit',
	'offsetmanagement',
	'community'
]);

// 스텔라 편의 기능 탭 버튼 Config
export const FUNC_CONV_TAB_BUTTON = Object.freeze([
	{ key: 'account', label: '어카운팅 인사이트', hash: 'account' },
	{ key: 'pharosAI', label: '말만해 AI', hash: 'pharosAI' },
	{ key: 'receiptocr', label: '영수증 업로드', hash: 'receiptocr' },
	{ key: 'bookmark', label: '즐겨찾기', hash: 'bookmark' },
	{ key: 'dashboard', label: '대시보드', hash: 'dashboard' },
	{ key: 'credit', label: '신용정보', hash: 'credit' },
	{ key: 'project', label: '프로젝트 관리', hash: 'project' },
	{ key: 'banking', label: '기업뱅킹 연동', hash: 'banking' },
	{ key: 'withholdingTax', label: '원천세 신고', hash: 'withholdingTax' },
	{ key: 'vat', label: '부가세 신고', hash: 'vat' },
	{ key: 'taxInvoice', label: '세금 계산서', hash: 'taxInvoice' },
	{ key: 'mim', label: '모바일 재고관리', hash: 'mim' },
	{ key: 'report', label: '보고서', hash: 'report' },
	{ key: 'costprofit', label: '기간비용 & 기간수익', hash: 'costprofit' },
	{ key: 'offsetmanagement', label: '반제관리', hash: 'offsetmanagement' },
	{ key: 'community', label: '세무대리인 소통함', hash: 'community' }
]);

// 스텔라 주요 기능 탭 Vod Config;
export const FUNC_TAB_VOD: Record<string, string[]> = Object.freeze({
	dashboard: [''],
	credit: [''],
	accountancy: [
		'https://www.youtube.com/embed/3oJ5vpw07D8?si=wb7chf637fD3uoZy?&vq=hd1080',
		'https://www.youtube.com/embed/elzyVUBYb-E?si=hdxLQgc7LZXo8Lmd?&vq=hd1080'
	],
	finance: [''],
	hr: [''],
	ledger: [''],
	report: [''],
	basis: [
		'https://www.youtube.com/embed/kEAPkKDk02w?si=O-2zIOTtDF1IHIbC?&vq=hd1080',
		'https://www.youtube.com/embed/ov6tKfR4Mrs?si=PsQj_4-w09NTFWnO?&vq=hd1080',
		'https://www.youtube.com/embed/asaqix9kgSE?si=Ant77TThMVEvoQLj?&vq=hd1080',
		'https://www.youtube.com/embed/WUiWkeqYvs0?si=KDXEqMRek09ZYH5V?&vq=hd1080',
		'https://www.youtube.com/embed/Z50S8LAQeKc?si=egT8qlYosSpwHDEc?&vq=hd1080',
		'https://www.youtube.com/embed/fai2edMMTH4?si=mvXy1nVjgjGfzFg6?&vq=hd1080',
		'https://www.youtube.com/embed/KCBmtq8-BQU?si=Qifcr7rDS5n8pPzX?&vq=hd1080'
	],
	dms: ['']
});

// 스텔라 특별한 기능 탭
export const FunctionTab = {
	cate: 'All-in-One Business Platform',
	title: '스텔라의 특별한 기능',
	subTab: [
		{ title: '주요 기능', link: NAV_PATH.FUNCTION.MAIN, cate: '주요 기능' },
		{ title: '편의 기능', link: NAV_PATH.FUNCTION.CONVENIENCE, cate: '편의 기능' }
	]
};
